import React, {useEffect, useRef} from 'react';
import {IonButton, IonButtons, IonContent, IonHeader, IonIcon, IonModal, IonToolbar} from '@ionic/react';
import MatrimonyFilterSidebar from "../components/MatrimonyFilterSidebar";
import MatrimonyProfileCard from "../components/MatrimonyProfileCard";
import MatrimonyProfileDetails from "../components/MatrimonyProfileDetails";
import useStore from "../zustand/useStore";
import {actionToGetMatrimonialPostingByFilter} from "../apiHelpers/CommonAction";
import {FacebookLoader} from "./Loader/FacebookLoader";
import {Virtuoso} from "react-virtuoso";
import NoDataFoundOrSelectedDiv from "./NoDataFoundOrSelectedDiv";
import {arrowBack} from "ionicons/icons";

export default function MatrimonialRoleBasedDataDesktop({isOpen,onDidDismiss,myJobPostsData,matrimonialProfileDetail,setMatrimonialProfileDetail}) {
    const {matrimonialPostingState,selectedReligion,selectedAge,
        selectedEducation,selectedLocation,selectedMeritialStatus,selectedHeight,selectedManglikStatus} = useStore();
    const {loading,profiles} = matrimonialPostingState;
    const isFetchingRef = useRef(false);

    const callFunctionToFilterMatrimonialPosting = async (isLoad = true) => {
        if (isFetchingRef.current) return;
        isFetchingRef.current = true;

        const payload = {};

        // Add matrimonial filters to payload
        if (selectedReligion.length > 0) payload.religion = selectedReligion;
        if (selectedAge > 0) payload.age = selectedAge;
        if (selectedEducation) payload.education = selectedEducation;
        if (selectedLocation.length > 0) payload.location = selectedLocation;
        if (selectedMeritialStatus.length > 0) payload.meritial_status = selectedMeritialStatus;
        if (selectedHeight > 0) payload.height = selectedHeight;
        if (selectedManglikStatus) payload.manglik_status = selectedManglikStatus;
        payload.me_mode = !!myJobPostsData;

        // Optional: pass limit/offset or pagination if needed
        payload.limit = 10;
        payload.offset = matrimonialPostingState.offset || 0;

        await actionToGetMatrimonialPostingByFilter(isLoad, payload);

        isFetchingRef.current = false;
    };

    useEffect(() => {
        if(profiles?.length){
            setMatrimonialProfileDetail(profiles[0]);
        }else{
            setMatrimonialProfileDetail(null);
        }
    },[profiles])


    useEffect(() => {
        if(isOpen){
            callFunctionToFilterMatrimonialPosting();
        }
    },[isOpen])

    return (
        <IonModal
            isOpen={isOpen}
            onDidDismiss={onDidDismiss}
            className={"modal_in_detail_desktop_full_view"}
        >
            <IonHeader className="job_detail_sheet_header sheet_modal_header">
                <IonToolbar>
                    <IonButtons slot="start">
                        <IonButton className={"close_job_post_button"} onClick={onDidDismiss}>
                            <IonIcon icon={arrowBack}/>
                        </IonButton>
                    </IonButtons>
                    <div className="job_detail_sheet_header_text">
                        <div className="job-basic-info-image">
                            <span className="job-basic-info-text">
                                Matrimonial Posts List
                            </span>a
                        </div>
                    </div>
                </IonToolbar>
            </IonHeader>
            <IonContent className="job-portal-desktop page-content">
                <div className="job-portal-container three-panel-grid">
                    {/* Filter Sidebar */}
                    <aside className="filter-sidebar">
                        <MatrimonyFilterSidebar/>
                    </aside>

                    <section className="job-list-section">
                        {(loading) ?
                            <div className={'job-list'}>
                                <div className={'job-card'}>
                                    <FacebookLoader type={"facebookStyle"} item={1}/>
                                </div>
                                <div className={'job-card'}>
                                    <FacebookLoader type={"facebookStyle"} item={1}/>
                                </div>
                                <div className={'job-card'}>
                                    <FacebookLoader type={"facebookStyle"} item={1}/>
                                </div>
                            </div>
                            :
                            (profiles && profiles?.length > 0) ?
                                <Virtuoso
                                    className={'job-list'}
                                    data={profiles}
                                    style={{height: 'calc(100vh - 115px)'}}
                                    endReached={() => callFunctionToFilterMatrimonialPosting(false)}
                                    overscan={5}
                                    itemContent={(index, profile) => (
                                        <MatrimonyProfileCard
                                            profile={profile}
                                            key={profile.id}
                                            selectedId={matrimonialProfileDetail?.id}
                                            handleProfileItemClick={setMatrimonialProfileDetail}
                                        />
                                    )}
                                />
                                :
                                <div className="job-list">
                                    <NoDataFoundOrSelectedDiv/>
                                </div>
                        }
                    </section>

                    <aside className="job-details-sidebar">
                        {(matrimonialProfileDetail?.id) ?
                            <MatrimonyProfileDetails matrimonialProfileDetail={matrimonialProfileDetail}/>
                            :
                            <NoDataFoundOrSelectedDiv isDetailPanel={true}/>
                        }
                    </aside>
                </div>
            </IonContent>
        </IonModal>
    );
}
